var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-sidebar"},[_c('div',{staticClass:"mt-3 text-center"},[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('UserAvatar',{attrs:{"nickname":_vm.nickname,"width":"4"},on:{"click":_vm.toProfile}})],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.nickname)+" ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }